// A PostHog $pageview each time the checkout moves between steps (ClickUp
// 869fepvk2). The steps share one path and differ only in ?step=, and PostHog's
// capture_pageview: 'history_change' reacts to a path change only, so Step 4 and
// every Back / Forward were never counted.
//
// Called after the URL is final (the step is written to the address before the
// screen changes), because the event reads the address and the page title as it
// captures. Not called for the first screen: PostHog already counts the landing.
//
// Telemetry must never break or slow a purchase: nothing here throws.
export function reportStepPageview() {
  try {
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture('$pageview');
    }
  } catch { /* never block checkout on telemetry */ }
}
